import { NavLink } from 'react-router-dom';
import { Instagram, Youtube, Facebook, Mail, Map } from 'lucide-react';
import { useDjangoData } from '@/contexts/DjangoContext';

const Footer = () => {
  const currentYear = new Date().getFullYear();
  
  const { data } = useDjangoData();
  return (
    <footer className="bg-adv-charcoal border-t border-adv-darkGray">
      <div className="container-custom py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {/* Brand/Logo */}
          <div className="space-y-4">
            <NavLink to="/" className="inline-block">
              <img 
                src={data.urls?.logo} 
                alt="Exodus ADV Logo" 
                className="h-16" 
              />
            </NavLink>
            <p className="text-adv-lightGray text-sm">
              Adventure motorcycle rallies, rides, and community.
            </p>
            <div className="flex space-x-4 pt-2">
              <a 
                href="https://instagram.com/Exodusadv" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-adv-lightGray hover:text-adv-orange transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://youtube.com/@Exodusadv" 
                target="_blank" 
                rel="noopener noreferrer"
                className="text-adv-lightGray hover:text-adv-orange transition-colors"
                aria-label="YouTube"
              >
                <Youtube size={20} />
              </a>
            </div>
          </div>
          
          {/* Quick Links */}
          <div>
            <h3 className="text-white font-medium mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <NavLink to="/rallies" className="text-adv-lightGray hover:text-adv-orange transition-colors text-sm">
                  ADV Rallies
                </NavLink>
              </li>
              <li>
                <NavLink to="/explore-rides" className="text-adv-lightGray hover:text-adv-orange transition-colors text-sm">
                  Explore Rides
                </NavLink>
              </li>
              <li>
                <NavLink to="/content-garage" className="text-adv-lightGray hover:text-adv-orange transition-colors text-sm">
                  Content Garage
                </NavLink>
              </li>
              <li>
                <NavLink to="/about" className="text-adv-lightGray hover:text-adv-orange transition-colors text-sm">
                  About Us
                </NavLink>
              </li>
            </ul>
          </div>
          
          {/* Resources */}
          <div>
            <h3 className="text-white font-medium mb-4">Resources</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-adv-lightGray hover:text-adv-orange transition-colors text-sm">
                  Rally FAQ
                </a>
              </li>
              <li>
                <a href="#" className="text-adv-lightGray hover:text-adv-orange transition-colors text-sm">
                  Packing Checklist
                </a>
              </li>
              <li>
                <a href="#" className="text-adv-lightGray hover:text-adv-orange transition-colors text-sm">
                  Rider Resources
                </a>
              </li>
              <li>
                <a href="#" className="text-adv-lightGray hover:text-adv-orange transition-colors text-sm">
                  Sponsorship
                </a>
              </li>
            </ul>
          </div>
          
          {/* Contact */}
          <div>
            <h3 className="text-white font-medium mb-4">Get In Touch</h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <Mail size={18} className="text-adv-orange mr-2 mt-0.5" />
                <a href="mailto:info@exodus-adv.com" className="text-adv-lightGray hover:text-adv-orange transition-colors text-sm">
                  ward.kennedy@exodusadv.com
                </a>
              </li>
              <li className="flex items-start">
                <Map size={18} className="text-adv-orange mr-2 mt-0.5" />
                <span className="text-adv-lightGray text-sm">
                  Based in Nashville, TN<br />
                  Riding Everywhere
                </span>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-adv-darkGray/50 mt-10 pt-6 flex flex-col md:flex-row justify-between items-center text-adv-lightGray text-xs">
          <p>© {currentYear} Exodus ADV. All rights reserved.</p>
          <div className="mt-4 md:mt-0 flex space-x-4">
            <a href="#" className="hover:text-adv-orange transition-colors">
              Privacy Policy
            </a>
            <a href="#" className="hover:text-adv-orange transition-colors">
              Terms of Service
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
